import React, { Dispatch, SetStateAction, useState } from 'react';
import { FormikErrors } from 'formik';
import styled from 'styled-components';

import { maskCpf, maskPassport } from '../../utils/masks';
import { validateCpf, validatePassport } from '../../utils/validators';
import { ModalConfirmDocument } from '../ModalConfirmDocument';
import { Dropdown } from '../Dropdown';

import { PatientProps } from '../../contexts/PatientContext';
import { InputValidation } from '../InputValidation';

export const FieldWrapper = styled.div`
  margin-top: 16px;
`;

export type ValidationDocumentProps = {
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
  setFieldError: (field: string, value: string | undefined) => void;
  document: string;
  documentType: string;
  error?: string | undefined;
  setIsValid: Dispatch<SetStateAction<boolean>>;
  isValid: boolean;
  onConfirmIdentity: () => void;
  showConfirmIdentity: boolean;
};

const ValidationDocument: React.FC<ValidationDocumentProps> = ({
  setFieldValue,
  setFieldError,
  document,
  documentType,
  error,
  setIsValid,
  isValid,
  onConfirmIdentity,
  showConfirmIdentity
}) => {
  const evaluateCpf = (value: string) => {
    const maskedCpf = maskCpf(value);
    setFieldValue('document', maskedCpf);
    if (!validateCpf(maskedCpf)) {
      if (maskedCpf.length > 0) {
        setFieldError('document', 'CPF inválido');
      }
      setIsValid(false);
    } else {
      setFieldError('document', '');
      setIsValid(true);
    }
  };

  const evaluatePassport = (value: string) => {
    const maskedPassaport = maskPassport(value);
    setFieldValue('document', maskedPassaport);
    if (!validatePassport(maskedPassaport)) {
      if (maskedPassaport.length > 0) {
        setFieldError('document', 'Passaporte inválido');
      }
      setIsValid(false);
    } else {
      setFieldError('document', '');
      setIsValid(true);
    }
  };

  function getLabelDocument(document: string) {
    return document.toUpperCase() === 'CPF' ? 'CPF' : 'Passaporte';
  }

  return (
    <>
      <FieldWrapper>
        <Dropdown
          label="Documento"
          placeholder="Documento"
          value={getLabelDocument(documentType)}
          onSelect={value => {
            setFieldValue('documentType', value);
            if (value === 'CPF') {
              setFieldValue('document', '');
              setFieldError('document', '');
              setIsValid(false);
            } else if (value === 'Passaporte') {
              setFieldValue('document', '');
              setFieldError('document', '');
              setIsValid(false);
            }
          }}
          options={['CPF', 'Passaporte']}
        />
      </FieldWrapper>
      <FieldWrapper>
        <InputValidation
          name="document"
          id="document"
          placeholder={`Digite seu ${getLabelDocument(documentType)}`}
          label={getLabelDocument(documentType)}
          type="text"
          filled={isValid && !!document}
          invalid={!isValid && !!document && document.length === 14}
          onChange={e => {
            if (documentType === 'CPF') {
              evaluateCpf(e.target.value);
            } else if (documentType === 'Passaporte') {
              evaluatePassport(e.target.value);
            }
          }}
          value={document}
          error={error}
        />
      </FieldWrapper>
      <ModalConfirmDocument
        documentType={documentType}
        visible={showConfirmIdentity}
        onConfirmIdentity={onConfirmIdentity}
      />
    </>
  );
};

export default ValidationDocument;
